import i18n from '@/i18n';
import { CLASS_NAME_MAX_LENGTH } from '@/features/class/manage/constants';
import type { ClassFormErrors, ClassFormValues } from '@/features/class/manage/types';

export function validateClassForm(values: ClassFormValues, isEdit: boolean): ClassFormErrors {
  const errors: ClassFormErrors = {};
  const t = (key: string, options?: Record<string, unknown>) =>
    i18n.t(key, { ns: 'class', ...options });

  if (!values.classType) {
    errors.classType = t('validationSelectClassType');
  }

  const name = values.name.trim();
  if (!name) {
    errors.name = t('validationEnterClassName');
  } else if (name.length > CLASS_NAME_MAX_LENGTH) {
    errors.name = t('validationClassNameMaxLength', { max: CLASS_NAME_MAX_LENGTH });
  }

  if (!values.academicYearId) {
    errors.academicYearId = t('validationSelectAcademicYear');
  }

  if (!values.gradeLevelId) {
    errors.gradeLevelId = t('validationSelectGrade');
  }

  const creditsRaw = values.credits.trim();
  if (creditsRaw) {
    const credits = Number(creditsRaw);
    if (!Number.isFinite(credits) || credits < 0) {
      errors.credits = t('validationInvalidCredits');
    }
  }

  void isEdit;
  return errors;
}

export function hasFormErrors(errors: ClassFormErrors): boolean {
  return Object.keys(errors).length > 0;
}
